<template>
  <div class="rounded-md bg-surface-primary border-1 border-border-primary">
    <div
      v-if="$slots.header"
      class="rounded-t-md border-b-1 border-border-primary"
      :class="[headerBgClass, headerTextClass, `${paddingY} ${paddingX}`]"
    >
      <slot name="header" />
    </div>
    <div :class="[`${paddingY} ${paddingX}`]">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { labelColorClass } from '~/utils';
interface Props {
  headerClass?: string;
  paddingY?: string;
  paddingX?: string;
}

const props = withDefaults(defineProps<Props>(), {
  headerClass: 'campaign',
  paddingY: 'py-24',
  paddingX: 'px-16',
});

const headerBgClass = computed(() => labelColorClass(props.headerClass));
const headerTextClass = computed(() => {
  if (headerBgClass.value === 'bg-label-black') {
    return 'text-white-50';
  }

  return '';
});
</script>

<style scoped></style>
